import React, { useContext, useEffect, useReducer, useRef, useState } from 'react';
import parse from 'html-react-parser';
import './RegistrationFormSection.css';
import { capitalize } from '../utils';
import { use } from 'i18next';
import HTMLReactParser from 'html-react-parser';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import EventContext from '../contexts/EventContext';

// Sections du formulaire qui affichent l'aperçu vidéo screen_manager à gauche de leurs instructions,
// avec les blocs passés en visible_section_id_list. Seule source de vérité : une section absente
// de cette table affiche son visuel fixe (formSectionVisuel) à la place.
// Une valeur peut être une fonction de l'id_event_ligne quand les blocs dépendent de l'événement.
export const SECTION_PREVIEW_BLOCKS = {
    1: idEventLigne => String(idEventLigne) === '663'
        ? 'camera_section,demo_presentation_section,logo_section,titrage_session_2'
        : 'titrage_session_haut_droit,titrage_session,custom_section,demo_presentation_right_section,contact_logo',
    12: 'camera_section,demo_presentation_section,logo_section,titrage_session_2',
    35: 'titrage_session_haut_droit,titrage_session,custom_section,demo_presentation_right_section,contact_logo',
    44: 'titrage_section,logo_section,video_stream_fullscreen_section',
};

const getSectionPreviewBlocks = (formSectionId, idEventLigne) => {
    const blocks = SECTION_PREVIEW_BLOCKS[Number(formSectionId)];
    return (typeof blocks === 'function' ? blocks(idEventLigne) : blocks) || '';
};

const RegistrationFormSection = ({ title, instructions, children, isError, subtitle, supertitle,
    formSectionId, formSectionVisuel }) => {

    const sectionPreviewRef = useRef(null);

    const [isSectionPreview, setIsSectionPreview] = useState(false);

    const [sectionIdPreview, setSectionIdPreview] = useState(null);

    const [isIframeModalOpen, setIsIframeModalOpen] = useState(false);

    const { idEvent, idContact } = useParams();

    const eventContext = useContext(EventContext);

    const { currentEvent } = eventContext;

    // Vide sans événement dans l'URL (/signup/... sans /events/:idEvent) : l'aperçu s'affiche quand même
    const idEventLigne = currentEvent?.event_ligne?.id_event_ligne ?? '';
    const visibleSectionIdList = getSectionPreviewBlocks(formSectionId, idEventLigne);
    const hasSectionPreview = visibleSectionIdList !== '';

    const instructionsBgColor = ["2146", "2269"].includes(idEvent) ? "bg-[#ecd593] dark:bg-[#7a6830]" : "bg-cyan-100 dark:bg-cyan-900/30";

    useEffect(() => {

        const url = new URL(window.location.href);
        const section_id_preview = url.searchParams.get("section_id_preview");
        setSectionIdPreview(section_id_preview);

        const handleScroll = () => {

            setTimeout(() => {
                sectionPreviewRef.current.scrollIntoView({ behavior: 'instant' });
            }, 3000)
        }

        if (section_id_preview === formSectionId?.toString()) {
            setIsSectionPreview(true);
            sectionPreviewRef.current.scrollIntoView({ behavior: 'instant' });

            window.addEventListener('load', handleScroll);
            const sectionHeight = sectionPreviewRef.current.clientHeight;

            const pageHeight = window.innerHeight;

            console.log('pageHeight', pageHeight);

            console.log('sectionHeight', sectionHeight);

            if (sectionHeight > pageHeight) {
                sectionPreviewRef.current.scrollIntoView({ behavior: 'instant' });
            }

            //a chaque fois que la hauteure de la page change, on scroll

            window.addEventListener('resize', function () {
                sectionPreviewRef.current.scrollIntoView({ behavior: 'instant' });

            });

        }


        return () => {
            window.removeEventListener('load', handleScroll);
        }

    }, [formSectionId])



    return <>

        {supertitle}


        <div
            ref={sectionPreviewRef}
            className={`relative registration-form-section ${isError ? 'bg-red-50 dark:bg-red-900/20' : ''} rounded p-2 my-4  ${isSectionPreview ? 'border-8 border-green-600 bg-green-50 dark:bg-green-900/20' : 'bg-white dark:bg-neutral-900 shadow-sm dark:shadow-neutral-800'}`}>

            {title && <h4 className="row pl-5 pb-3 text-2xl font-bold text-gray-800 dark:text-white">{capitalize(title)}</h4>}

            {sectionIdPreview && <div className="bg-emerald-100 dark:bg-emerald-900/30 p-3 border-x border-y border-emerald-600 my-2 text-gray-800 dark:text-emerald-300">Section id : {formSectionId}</div>}

            {((instructions && !Array.isArray(instructions)) || (Array.isArray(instructions) && instructions.length > 0)) &&

                <div className={`flex flex-col lg:flex-row rounded my-2 ${instructionsBgColor} p-3 space-x-3 items-center text-gray-800 dark:text-neutral-100 dark:[&_*]:text-neutral-100 dark:[&_a]:text-cyan-300 dark:[&_strong]:text-white`}>
                    {hasSectionPreview && (<>
                        <div className="relative" style={{ width: '320px', height: '180px' }}>
                            <div className="overflow-hidden rounded" style={{ width: '320px', height: '180px' }}>
                                <iframe
                                    title="Aperçu section"
                                    loading="lazy"
                                    src={`https://www.event2one.com/screen_manager/content/contact/index.dev.php?id_cycle_lang=&id_contact=${idContact || '227438'}&content=background_image&target=controle&id_event_ligne=${idEventLigne}&fiche_production_mode=game_changer&id_formulaire_list=&id_scene_virale=&visible_section_id_list=${visibleSectionIdList}`}
                                    style={{
                                        width: '1280px',
                                        height: '720px',
                                        transform: 'scale(0.25)',
                                        transformOrigin: 'top left',
                                        border: 'none',
                                        pointerEvents: 'none',
                                    }}
                                />
                            </div>
                            <button
                                type="button"
                                className="absolute bottom-1 right-1 z-10 bg-black/60 hover:bg-black/80 text-white px-2 py-1 rounded text-xs cursor-pointer"
                                onClick={() => setIsIframeModalOpen(true)}
                            >&#x26F6; Agrandir</button>
                        </div>

                        {isIframeModalOpen && (
                            <div
                                className="fixed inset-0 z-50 flex items-center justify-center bg-black/70"
                                onClick={() => setIsIframeModalOpen(false)}
                            >
                                <div
                                    className="relative bg-white dark:bg-neutral-900 rounded-lg shadow-2xl p-2"
                                    onClick={(e) => e.stopPropagation()}
                                >
                                    <button
                                        className="absolute -top-3 -right-3 bg-red-500 hover:bg-red-600 text-white rounded-full w-8 h-8 flex items-center justify-center text-lg font-bold shadow-lg z-10"
                                        onClick={() => setIsIframeModalOpen(false)}
                                    >&times;</button>
                                    <iframe
                                        title="Aperçu section plein écran"
                                        loading="lazy"
                                        src={`https://www.event2one.com/screen_manager/content/contact/index.dev.php?id_cycle_lang=&id_contact=${'227438'}&content=background_image&target=controle&id_event_ligne=${idEventLigne}&fiche_production_mode=game_changer&id_formulaire_list=&id_scene_virale=&visible_section_id_list=${visibleSectionIdList}`}
                                        style={{
                                            width: '1280px',
                                            height: '720px',
                                            border: 'none',
                                        }}
                                    />
                                </div>
                            </div>
                        )}
                    </>)}


                    {!hasSectionPreview && formSectionVisuel !== "https://www.mlg-consulting.com/manager_cc/docs/archives/thumbs/_500x0." && formSectionVisuel &&
                        <div className="flex flex-col justify-center items-center pb-3 basis-2/12">
                            <img src={formSectionVisuel} alt="" className="w-72 object-cover" />
                        </div>}
                    <div className="basis-10/12">
                        {typeof instructions === 'string' ? HTMLReactParser(instructions) : null}
                    </div>
                </div>
            }
            {children}
        </div>
    </>
}

export default RegistrationFormSection;
